import { useContext } from "react";
import { DesktopNotificationContext } from "../contexts/desktopNotification";

const useDesktopNotification= () => {

    return useContext(DesktopNotificationContext);

};

export default useDesktopNotification;